import {
  SidebarProvider,
  useSidebar as useSidebarImpl,
} from "@needl-ai/common/components/ui/sidebar";

export const AppSidebarProvider: React.FC<AppSidebarProviderProps> = ({
  children,
}) => {
  return <SidebarProvider>{children}</SidebarProvider>;
};

export const useSidebar = useSidebarImpl;

type AppSidebarProviderProps = {
  children: React.ReactNode;
};
